export const MAIN_ANALYTICS_CHART_COLORS = [
   '#1976d2',
   '#dd6b20',
   '#2f9e44',
   '#2c9c9c',
   '#8b5cf6',
   '#e11d48',
];

export const chartNumberFormatter = new Intl.NumberFormat('en-US');

export const formatChartNumber = (value: number) => chartNumberFormatter.format(value);
